export function showOverlay(selectorOrEl, data = {}) {
  return new Promise((resolve) => {
    let el = document.createElement("div");

    const templateEl =
      selectorOrEl instanceof HTMLElement
        ? selectorOrEl
        : document.querySelector(selectorOrEl);

    if (!templateEl) {
      return;
    }

    let htmlContent = templateEl.innerHTML;

    for (const [key, value] of Object.entries(data)) {
      htmlContent = htmlContent.replace(new RegExp(`{{${key}}}`, "g"), value);
    }

    el.innerHTML = htmlContent;

    const overlay = el.querySelector(".overlay");

    if (!(overlay instanceof HTMLElement)) {
      return;
    }

    const wrapperEl = document.createElement("div");
    wrapperEl.classList.add("tailwind-container");
    wrapperEl.append(overlay);

    overlay.addEventListener("overlay", () => {
      overlay.classList.remove("--show");
      setTimeout(() => {
        wrapperEl.remove();
      }, 500);
      resolve(true);
    });

    overlay.addEventListener("keydown", function (event) {
      event.key === "Escape" && closeOverlay(this);
    });

    const closeBtns = [...overlay.querySelectorAll("[data-overlay-close]")];

    for (const closeBtn of closeBtns) {
      closeBtn.addEventListener("click", () => closeOverlay(closeBtn));
    }

    document.body.append(wrapperEl);
    overlay.focus();
  });
}

export function closeOverlay(el) {
  el.dispatchEvent(
    new CustomEvent("overlay", { bubbles: true, detail: false })
  );
}

window.Overlay = { show: showOverlay, close: closeOverlay };
